module.exports = __webpack_public_path__ + "img/18.e400dbc7.jpg";